export const organization = {
  id: 12,
  name: 'BIG Corp',
  internal_code: 'B123',
  teams: []
};